import * as Mui from "@mui/material";
import { useEffect } from "react";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import FormInput from "../../common/FormInput";
import { nameof } from "../../common/ObjectUtils";

export interface ITaskStatus {
    open?: boolean,
    openingDate?: string,
    openingUser?: string,
    closeDate?: string,
    closeUser?: string,
}

interface Props{
    formInfo ?: ITaskStatus;
    onComponentDidMount?: (val: number) => void;
};

const TaskStatus = (props: Props) => {
    const t = useOperationTranslation();
    
    useEffect(() => {
        props.onComponentDidMount && props.onComponentDidMount(2);
    }, []);

    return(
        <Mui.Card>
            <Mui.CardHeader
                title={
                    <Mui.Typography>
                        {t("damageForm.details.common.taskStatus.title")}
                    </Mui.Typography>
                }
            />
            
            <Mui.CardContent>
                <Mui.Grid container spacing={2}>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <Mui.Autocomplete
                            value={props.formInfo?.open === true
                                ? t("damageForm.details.common.taskStatus.labels.statusOpen")
                                : t("damageForm.details.common.taskStatus.labels.statusClosed")}
                            options={[]}
                            fullWidth
                            disabled 
                            renderInput={(args) => {
                                return(
                                    <Mui.TextField 
                                        {...args}
                                        label="Status"
                                    />
                                )
                            }}
                        />
                    </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container spacing={2}>
                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<ITaskStatus>("openingDate")}
                            type="date"
                            value={props.formInfo?.openingDate}
                            label={t("damageForm.details.common.taskStatus.labels.openingDate")}
                            fullWidth
                            disabled
                        /> 
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            label={t("damageForm.details.common.taskStatus.labels.openingUser")}
                            value={props.formInfo?.openingUser || ""} 
                            name={nameof<ITaskStatus>("openingUser")}
                            type="text"
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput
                            name={nameof<ITaskStatus>("closeDate")}
                            type="date"
                            label={t("damageForm.details.common.taskStatus.labels.closingDate")}
                            value={props.formInfo?.closeDate || null }
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>

                    <Mui.Grid item xs={12} sm={6} md={3}>
                        <FormInput 
                            label={t("damageForm.details.common.taskStatus.labels.closingUser")}
                            value={props.formInfo?.closeUser || ""} 
                            name={nameof<ITaskStatus>("closeUser")}
                            type="text"
                            fullWidth
                            disabled
                        />
                    </Mui.Grid>

                </Mui.Grid>
            </Mui.CardContent>
        </Mui.Card>
    )
}
export default TaskStatus;